import { render, staticRenderFns } from "./TiptapVuetify.vue?vue&type=template&id=1986814a&scoped=true"
import script from "./TiptapVuetify.vue?vue&type=script&lang=js"
export * from "./TiptapVuetify.vue?vue&type=script&lang=js"
import style0 from "./TiptapVuetify.vue?vue&type=style&index=0&id=1986814a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986814a",
  null
  
)

export default component.exports